import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Helps catch a missing/forgotten .env restart during development.
  console.warn(
    'Supabase env vars are missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in my-calendar-app/.env and restart `npm start`.'
  );
}

// createClient throws on an empty url/key, which would white-screen the whole
// app before the env vars are filled in. Fall back to harmless placeholders so
// the app still boots to the sign-in screen; auth calls simply fail until the
// real values are added.
// detectSessionInUrl (default true) parses the #access_token from invite /
// password-recovery email links so the app can complete those flows.
export const supabase = createClient(
  supabaseUrl || 'http://localhost:54321',
  supabaseAnonKey || 'public-anon-key-placeholder'
);
